import React from "react";

const BankTransfersCategoryBadge = ({
    category,
    emptyText = "Brak kategorii"
}) => {
    if (!category) {
        return (
            <span className="transfer-category-pill transfer-category-pill-empty">
                {emptyText}
            </span>
        );
    }

    if (category.id === 0) {
        return (
            <span className="transfer-category-pill transfer-category-pill-empty">
                {category.name}
            </span>
        );
    }

    return (
        <span
            className={`transfer-category-pill transfer-category-group-${category.groupId}`}
            title={category.groupName}
        >
            {category.name}
        </span>
    );
};

export default BankTransfersCategoryBadge;